import React from 'react';
import { TvIllustration } from '../TvIllustration/TvIllustration';
import { styles } from './ErrorMessage.css';
import { Link } from '../PlatformFunctionality';
import { NoResultsPlaceholder } from '../NoResultsPlaceholder/NoResultsPlaceholder';
import { ContentBlock } from '../ContentBlock';

export type ErrorMessageProps = {
  variant?: 'default' | 'contentBlock';
};

export const ErrorMessage = ({ variant = 'default' }: ErrorMessageProps) => {
  if (variant === 'default') {
    return (
      <div className={styles.container}>
        <h1>Sorry, something went wrong!</h1>
        <p className={styles.intro}>
          Looks like this page had a few cables loose, please try refresh the page or{' '}
          <Link className={styles.link} href="/">
            head back home
          </Link>
          .
        </p>

        <div className={styles.illustration}>
          <TvIllustration />
        </div>
      </div>
    );
  }

  return (
    <ContentBlock>
      <NoResultsPlaceholder
        title="Sorry, something went wrong!"
        icon={<TvIllustration width={200} />}
        contents="Looks like this section had a few cables loose, please try refreshing the page."
      />
    </ContentBlock>
  );
};
